
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export const adGroupTypeEnum = {
  SearchStandard: 'SearchStandard',
  SearchDynamic: 'SearchDynamic',
};

export const adGroupTypeText = {
  SearchStandard: i18n.getString('AdGroupType_SearchStandard'),
  SearchDynamic: i18n.getString('AdGroupType_SearchDynamic'),
};
